export default __webpack_public_path__ + "static/media/diploma.3d0be271.png";